/* eslint-disable @next/next/no-html-link-for-pages */
import { useContext } from 'react';

import { trackElementInteraction } from '@/common/analytics/gtm/shared/trackElementInteraction';
import { ResolutionsSrcSet, StaticImage } from '@/common/constants/displateRoutes';
import { AuthContext } from '@/contexts/auth/AuthContext';

import styles from './Following.module.scss';

const FollowingEmptyState = () => {
  const { userInfo } = useContext(AuthContext);

  const { isUserLoggedIn } = userInfo || {};

  return (
    <div className={styles.emptyState}>
      <img
        alt="black and white image with box of Displates"
        height={159}
        src={StaticImage('/images/following/empty_state.png')}
        srcSet={ResolutionsSrcSet({
          x1: StaticImage('/images/following/empty_state.png'),
          x2: StaticImage('/images/following/empty_state@2x.png'),
        })}
        width={230}
      />
      <p className={styles.info}>
        {isUserLoggedIn
          ? 'Start following brands to see the newest releases'
          : 'Log in and start following brands to see the newest releases'}
      </p>
      <a
        className={styles.link}
        href="/browse-brands"
        onClick={() => trackElementInteraction({ elementId: 'see_all_brands_button' })}
      >
        See all brands
      </a>
    </div>
  );
};

export default FollowingEmptyState;
